import { FC } from "react";
import classNames from "classnames";

import { BadgeProps } from "./types"; 

import styles from "./Badge.module.css";



const Badge: FC<BadgeProps> = ({
  text,
  size = "md",
  className,
}) => {
  const sizeClass = size === "sm" ? styles["size__sm"] : styles["size__md"];
  const classNamesList = classNames(styles["badge"], sizeClass, className);

  return (
    <span className={classNamesList}>{text}</span>
  );  
};

export default Badge;
